'use client'

import { useEffect, useState } from 'react'
import { ArrowUp } from '@phosphor-icons/react'

export function BlogBackToTop({ threshold = 800 }: { threshold?: number }) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > threshold)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [threshold])

  return (
    <button
      type="button"
      className={`blog-back-to-top ${visible ? 'blog-back-to-top--visible' : ''}`}
      aria-label="Back to top"
      onClick={() => {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        window.scrollTo({ top: 0, behavior: reduced ? 'instant' : 'smooth' })
      }}
    >
      <ArrowUp size={18} weight="bold" />
    </button>
  )
}
